import { createBrowserRouter } from "react-router-dom";
import RootLayout from "./layouts/RootLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Resume from "./pages/Resume";
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import Architecture from "./pages/projects/Architecture";
import ProductDesign from "./pages/projects/ProductDesign";
import VirtualArchitecture from "./pages/projects/VirtualArchitecture";
import TraceBim from "./pages/projects/TraceBim";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "resume",
        element: <Resume />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "projects",
        element: <Projects />,
      },
      {
        path: "projects/arch",
        element: <Architecture />,
      },
      {
        path: "projects/productDesign",
        element: <ProductDesign />,
      },
      {
        path: "projects/virtualArch",
        element: <VirtualArchitecture />,
      },
      {
        path: "projects/trace-bim",
        element: <TraceBim />,
      },
    ],
  },
]);
